//import config from '../config';
import React,{Component} from "react";
//import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Monthly_attendance from "./Monthly_attendance";
import Monthly_attendance_date from "./Monthly_attendance_date";
//import AttendanceHours from "./AttendanceHours";
import AttendanceDuringDate from "./AttendanceDuringDate";
const axios = require("axios");
const ref = React.createRef();
class EmployeeAttendance extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none",tab4:"none"};
    }
    render(){
        return(
            <div className="containera1">
                <br></br>
                    <div >
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
//                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none",tab4:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none",tab4:"none" }); else if(newValue == 2) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block",tab4:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none",tab4:"block"}) ;                                                             
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none" }); else if(newValue == 2) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block"}); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none"}) ;                                                             
                            }}
                            >
                            <Tab label="Monthly attendance sheet" > </Tab> 
                            <Tab label="Periodic Attendance sheet" > </Tab> 
                            <Tab label="Employee daily attendance"></Tab>
                        </Tabs>
                    </div>
                    <div  style={{display:this.state.tab1}}>
                            <Monthly_attendance/>
                    </div>
                    <div  style={{display:this.state.tab2}}>
                            <Monthly_attendance_date/>
                    </div>


                    <div  style={{display:this.state.tab3}}>
                          <AttendanceDuringDate/>
                    </div>
                    <br></br>
                </div>
    )}
}
export default EmployeeAttendance;